import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CadastroService } from '../../../../../services/cadastro.service';
import { ParametrosService } from '../../../../../services/parametros.service';
import { Cargo } from '../../../../../models/cadastro.model';
import { Parametros } from '../../../../../models/parametros.model';
import { CommonModule } from '@angular/common';
import { ErrorModel } from '../../../../../models/error.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cargo-manutencao',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './cargo-manutencao.component.html',
  styleUrls: ['./cargo-manutencao.component.css']
})
export class CargoManutencaoComponent implements OnInit {
  cargoForm: FormGroup;
  cargoId: number = 0;
  isEditMode = false;
  isLoading = false;
  niveis: Parametros[] = [];

  private fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private cadastroService = inject(CadastroService);
  private parametrosService = inject(ParametrosService);
  private router = inject(Router);
  private toastr = inject(ToastrService);

  constructor() {
    this.cargoForm = this.fb.group({
      descricao: ['', [Validators.required]],
      nivel: ['', [Validators.required]],
      salarioBase: [0, [Validators.required, Validators.min(0)]],
      valeAlimentacao: [0, [Validators.required, Validators.min(0)]],
      valeRefeicao: [0, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnInit(): void {
    this.loadNiveis();
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.cargoId = params['id'];
        this.isEditMode = true;
        this.loadCargo(this.cargoId);
      }
    });
  }

  loadNiveis(): void {
    this.parametrosService.getParametrosByCategorias(['NIVEL_CARGO']).subscribe({
      next: (data) => {
        this.niveis = data;
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar níveis.');
      }
    });
  }

  loadCargo(id: number): void {
    this.isLoading = true;
    this.cadastroService.getCargoById(id).subscribe({
      next: (cargo) => {
        this.cargoForm.patchValue(cargo);
        this.isLoading = false;
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar cargo.');
        this.isLoading = false;
      }
    });
  }

  salvar(): void {
    if (!this.cargoForm.valid) {
      this.toastr.warning('Preencha todos os campos obrigatórios.');
      return;
    }

    this.isLoading = true;
    let cargo: Cargo = this.cargoForm.value;

    if (this.isEditMode) {
      cargo.id = this.cargoId;
    }

    const operation = this.isEditMode
      ? this.cadastroService.updateCargo(cargo)
      : this.cadastroService.createCargo(cargo);

    operation.subscribe({
      next: () => {
        const mensagem = this.isEditMode ? 'Cargo atualizado com sucesso!' : 'Cargo criado com sucesso!';
        this.toastr.success(mensagem);
        this.router.navigate(['/home', 'cadastro-cargo']);
        this.isLoading = false;
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao salvar cargo.');
        this.isLoading = false;
      }
    });
  }

  cancelar(): void {
    this.router.navigate(['/home', 'cadastro-cargo']);
  }

  get descricao() {
    return this.cargoForm.get('descricao');
  }

  get nivel() {
    return this.cargoForm.get('nivel');
  }

  get salarioBase() {
    return this.cargoForm.get('salarioBase');
  }

  get valeAlimentacao() {
    return this.cargoForm.get('valeAlimentacao');
  }

  get valeRefeicao() {
    return this.cargoForm.get('valeRefeicao');
  }
}
